import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true  // Enable credentials for CORS
});

// Request interceptor — accept both auth flavors: Stytch web sessions
// (sessionStorage) and phone-signup sessions (localStorage ci_session_token)
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('session_token')
      || localStorage.getItem('ci_session_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    const businessId = sessionStorage.getItem('active_business_id');
    if (businessId) {
      config.headers['X-Business-Id'] = businessId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — only force login when NO credentials exist at all;
// a transient 401 for a phone-signup user must not wipe their session.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadPhoneSession = !!localStorage.getItem('ci_session_token');
      sessionStorage.removeItem('session_token');
      sessionStorage.removeItem('session_jwt');
      if (!hadPhoneSession) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
